// Prompt-Vorlagen für SNAPSHOT
// 100 vordefinierte Bildideen - Kategorisiert nach Bildstilen
// User kann Vorlagen übernehmen und eigene Änderungen hinzufügen

export const PROMPT_TEMPLATES = [
  
  // ═══════════════════════════════════════════════════════════════
  // 🎬 KINO-LOOK (Standard Cinematic)
  // ═══════════════════════════════════════════════════════════════
  
  {
   category: "cinematic",
   short: "Monaco Hafen, schwarzes Outfit, Champagnerglas, Luxusyachten",
   full: "Ich am Hafen von Monaco auf einer eleganten Terrasse sitzend, schwarzes Designer-Abendoutfit tragend, ein Champagnerglas in der Hand haltend, glitzernde Luxusyachten im Hintergrund, entspannte und luxuriöse Atmosphäre, filmische Komposition"
 },
 {
   category: "cinematic",
   short: "NY Rooftop, schwarzes Outfit, Champagner, Skyline",
   full: "Ich auf einem New Yorker Rooftop stehend, schwarzes elegantes Abendoutfit, Champagner in der Hand, glitzernde Manhattan Skyline im Hintergrund, Wolkenkratzer-Lichter, urbane Eleganz, filmischer Stadtblick"
 },
 {
   category: "cinematic",
   short: "Dubai Marina, elegantes Outfit, Wolkenkratzer, Yachten",
   full: "Ich an der Dubai Marina promenierend, elegantes Abendoutfit, moderne Wolkenkratzer, luxuriöse Yachten im Wasser, orientalische Moderne, cinematisches Stadtpanorama"
 },
 {
   category: "cinematic",
   short: "Luxushotel-Lobby, elegantes Abendoutfit, Kronleuchter, Marmorboden",
   full: "Ich in einer Luxushotel-Lobby stehend, elegantes Abendoutfit, prachtvoller Kronleuchter über mir, polierter Marmorboden, opulente Atmosphäre, filmischer Glanz"
 },
 {
   category: "cinematic",
   short: "Venedig Gondel, romantisches Outfit, Kanäle, Brücken",
   full: "Ich in einer venezianischen Gondel sitzend, romantisches elegantes Outfit, historische Kanäle und Brücken, italienischer Charme, filmische Romantik"
 },
 {
   category: "cinematic_epic",
   short: "Las Vegas Strip, Party-Outfit, Neonlichter, Casino",
   full: "Ich am Las Vegas Strip stehend, glamouröses Party-Outfit, bunte Neonlichter überall, Casino-Atmosphäre, dramatische Weitwinkel-Komposition, episches Stadt-Panorama, Hollywood-Blockbuster-Feeling"
 },
 {
   category: "cinematic_epic",
   short: "Hong Kong Skyline, urbanes Outfit, Wolkenkratzer",
   full: "Ich vor der Hong Kong Skyline stehend, modernes urbanes Outfit, massiv leuchtende Wolkenkratzer, heroische Perspektive von unten, epische Stadt-Komposition, Blockbuster-Atmosphäre"
 },
 {
   category: "cinematic_epic",
   short: "Shanghai Bund, elegantes Outfit, Pudong, moderne Architektur",
   full: "Ich am Shanghai Bund stehend, elegantes Outfit, die massive Pudong Skyline vor mir, futuristische Wolkenkratzer, epische Stadtsilhouette, Blockbuster-Szenerie"
 },
 {
   category: "cinematic_epic",
   short: "Sydney Opera House, Smart Casual, Harbour, maritim",
   full: "Ich vor dem Sydney Opera House stehend, Smart Casual Outfit, die ikonische Oper und Harbour Bridge im Hintergrund, weiter Blick über den Hafen, epische Landmark-Komposition, australische Grandiosität"
 },
 {
   category: "cinematic_epic",
   short: "Rio Christusstatue, brasilianisches Outfit, Corcovado, Panorama",
   full: "Ich an der Cristo Redentor Statue in Rio stehend, buntes brasilianisches Outfit, die massive Christusstatue über mir, atemberaubendes Panorama über Rio, dramatischer Weitwinkel, epische Monumentalität, Blockbuster-Perspektive"
 },
 {
   category: "cinematic_noir",
   short: "Gotham City, Batman-Kostüm, Umhang, regennasse Straßen",
   full: "Ich in einer dunklen Gotham City Gasse stehend, detailliertes Batman-Kostüm mit wehendem Umhang, Straßen die Neonlichter reflektieren, düstere Hochhäuser über mir, dramatische Noir-Atmosphäre, kontrastreiches Licht und Schatten"
 },
 {
   category: "cinematic_noir",
   short: "London Soho, Trenchcoat, Regenschirm, nasse Straßen",
   full: "Ich in den dunklen Straßen von London Soho gehend, klassischer Trenchcoat, Regenschirm in der Hand, nasse reflektierende Straßen, dramatische Schatten, Noir-Stimmung, geheimnisvolles Licht"
 },
 {
   category: "cinematic_noir",
   short: "NY U-Bahn, Hoodie, Kopfhörer, Graffitiwände",
   full: "Ich in einer verlassenen New Yorker U-Bahn-Station stehend, dunkler Hoodie, Kopfhörer auf, Graffitiwände um mich herum, dramatisches Neon-Licht, urbane Noir-Atmosphäre, kontrastreiches Schattenspiel, düstere Subway-Stimmung"
 },
 {
   category: "cinematic_noir",
   short: "Jazz-Bar, Vintage-Outfit, Mikrofon, rote Samtvorhänge",
   full: "Ich in einer düsteren Jazz-Bar stehend, Vintage-inspiriertes Outfit, altes Mikrofon vor mir, rote schwere Samtvorhänge im Hintergrund, dramatisches Spotlight, rauchige Atmosphäre, Noir-Stimmung, kontrastreiches Licht"
 },
 {
   category: "cinematic_noir",
   short: "Winterliche Großstadt, langer Mantel, Schal, Schneeflocken",
   full: "Ich in einer winterlichen Großstadt gehend, langer dunkler Mantel, dicker Schal, nasse Straßen die Lichter reflektieren, einsame Atmosphäre, dramatischer Noir-Look, geheimnisvolle Stimmung"
 },
 {
   category: "cinematic_vintage",
   short: "Havanna Oldtimer, Vintage-Outfit, Pastellfarben, kubanisch",
   full: "Ich vor einem klassischen Havanna Oldtimer stehend, authentisches Vintage-Outfit, Pastellfarben überall, kubanische Straße, analoger Film-Look, verblasste Farben, Retro-Ästhetik, nostalgische 50er-Jahre-Stimmung"
 },
 {
   category: "cinematic_vintage",
   short: "Pariser Straßencafé, lockeres Outfit, Croissant, Hausfassaden",
   full: "Ich in einem klassischen Pariser Straßencafé sitzend, lockeres Vintage-Outfit, Croissant auf dem Tisch, historische Hausfassaden, Retro-Film-Look, nostalgische französische Atmosphäre"
 },
 {
   category: "cinematic_vintage",
   short: "Oldtimer-Garage, Workwear, Werkzeug, klassische Autos",
   full: "Ich in einer Oldtimer-Garage stehend, klassische Workwear, Werkzeug in der Hand, glänzende klassische Autos um mich, Retro-Ästhetik, nostalgische Garage-Atmosphäre, analoger Film-Look"
 },
 {
   category: "cinematic_vintage",
   short: "Miami Ocean Drive, sommerliches Outfit, Oldtimer, Palmen",
   full: "Ich am Miami Ocean Drive flanierend, sommerliches Retro-Outfit, klassische amerikanische Oldtimer, Palmen, Art Deco Gebäude, Vintage-Film-Look, 80er-Jahre Miami-Vibe"
 },
 {
   category: "cinematic_moody",
   short: "Norwegen Fjord, Regenjacke, Bootssteg",
   full: "Ich an einem norwegischen Fjord auf einem Bootssteg stehend, dunkle Regenjacke, dramatische Berge im Hintergrund, melancholische Stimmung, gedämpfte Farben, introspektive Atmosphäre, emotionale Tiefe"
 },
 {
   category: "cinematic_moody",
   short: "Island Nordlichter, Winterjacke, Aurora, mystisch",
   full: "Ich unter isländischen Nordlichtern stehend, warme dunkle Winterjacke, grün-violette Aurora am Himmel, schwarze Lavafelder, mystische düstere Landschaft, melancholische Stimmung, emotionale Atmosphäre"
 },
 {
   category: "cinematic_moody",
   short: "Lappland Polarlichter, Winteroverall, Schneefläche, Sternenhimmel",
   full: "Ich in Lappland unter Polarlichtern stehend, dunkler Winteroverall, endlose Schneefläche, Aurora und Sternenhimmel, einsame Weite, melancholische Winterstimmung, introspektive Atmosphäre, emotionale Tiefe"
 },
 {
   category: "fashion",
   short: "Paris Eiffelturm, elegantes Outfit, Caféterrasse",
   full: "Ich auf einer Pariser Caféterrasse nahe dem Eiffelturm sitzend, elegantes chicces Outfit, der Eiffelturm im Hintergrund, französische Eleganz, Fashion-Fotografie-Stil"
 },
 {
   category: "fashion",
   short: "Barcelona Sagrada Familia, Sommeroutfit, Gaudi",
   full: "Ich vor der Sagrada Familia in Barcelona stehend, luftiges modisches Sommeroutfit, Gaudis spektakuläre Architektur, spanischer Style, Fashion-Fotografie-Ästhetik"
 },
 {
   category: "fashion",
   short: "Tokyo Kirschblüten, Kimono-inspiriert, rosa Blüten, Japan",
   full: "Ich unter Tokios Kirschblüten stehend, Kimono-inspiriertes modernes Outfit, rosa Blütenmeer, japanischer Garten, asiatische Fashion-Eleganz, editorial Style"
 },
 {
   category: "fashion",
   short: "Seoul Gangnam, K-Pop Style, moderne Architektur",
   full: "Ich in Seoul Gangnam laufend, trendiger K-Pop inspirierter Style, hochmoderne Architektur, koreanische Mode-Ästhetik, urbane Fashion-Fotografie, editorial Komposition"
 },
 {
   category: "fashion_glamour",
   short: "Dubai Beach Club, Badekleidung, Sonnenliege, Palmen",
   full: "Ich in einem exklusiven Dubai Beach Club auf einer Sonnenliege liegend, glamouröse Badekleidung, Palmen und Infinity-Pool, türkisblaues Meer, luxuriöse Resort-Atmosphäre, Hochglanz-Fotografie"
 },
 {
   category: "fashion_glamour",
   short: "Malediven Overwater-Bungalow, Badekleidung, kristallklar",
   full: "Ich auf einem Malediven Overwater-Bungalow Deck stehend, luxuriöse Designer-Badekleidung, kristallklares türkises Wasser unter mir, endloser Horizont, tropische Luxus-Atmosphäre, Hochglanz Fashion-Fotografie"
 },
 {
   category: "fashion_glamour",
   short: "Rooftop-Pool, Swimwear, Skyline",
   full: "Ich an einem Rooftop Infinity-Pool stehend, Designer Swimwear, dramatische Skyline im Hintergrund, urbaner Luxus, glamouröse Atmosphäre, Hochglanz-Fotografie-Stil"
 },
 {
   category: "fashion_glamour",
   short: "Ibiza Beach Club, Sommeroutfit, Cocktailglas, DJ-Pult",
   full: "Ich in einem exklusiven Ibiza Beach Club stehend, trendiges Sommer-Designer-Outfit, Cocktailglas in der Hand, DJ-Pult im Hintergrund, mediterrane Luxus-Atmosphäre, glamouröse Vibes, Hochglanz-Style"
 },
 {
   category: "fashion_editorial",
   short: "Studio-Porträt, minimalistisches Outfit, schwarzer Hintergrund, Spotlight",
   full: "Ich in einem professionellen Fotostudio stehend, minimalistisches hochwertiges Outfit, komplett schwarzer Hintergrund, dramatisches Spotlight von oben, scharfer Fokus, editorial Magazin-Qualität, Vogue-Ästhetik"
 },
 {
   category: "fashion_editorial",
   short: "Loft-Atelier, Casual Chic, Leinwand, Farbspritzer",
   full: "Ich in einem minimalistischen Loft-Atelier stehend, Casual Chic Designer-Outfit, große weiße Leinwand mit Farbspritzern, künstlerische Atmosphäre, editorial Fashion-Fotografie, professionelles Styling"
 },
 {
   category: "fashion_editorial",
   short: "Toskana Weinberge, smart-casual Outfit, Weinglas",
   full: "Ich in toskanischen Weinbergen stehend, smart-casual elegantes Outfit, Weinglas in der Hand, sanfte Hügel, italienische Landschaft, editorial Fashion-Komposition"
 },
 {
   category: "fashion_vintage",
   short: "Lissabon Straßenbahn, casual chic, gelbe Tram, Pastell",
   full: "Ich vor Lissabons ikonischer gelber Straßenbahn stehend, Retro casual chic Outfit, Pastell-Häuser, portugiesischer Vintage-Flair, analoger Film-Look, nostalgische Farben, 70er-Jahre-Ästhetik"
 },
 {
   category: "fashion_vintage",
   short: "Kopenhagen Nyhavn, Hygge-Outfit, bunte Häuser, Kanal",
   full: "Ich an Kopenhagens Nyhavn Kanal stehend, gemütliches Hygge-Retro-Outfit, bunte historische Häuser, skandinavische Vintage-Atmosphäre, nostalgischer nordischer Charme"
 },
 {
   category: "realistic_natural",
   short: "Santorini Klippen, weißes Outfit, Ägäis",
   full: "Ich auf den Klippen von Santorini stehend, weißes luftiges Outfit, weiße Häuser, authentischer griechischer Charme, realistische Fotografie"
 },
 {
   category: "realistic_natural",
   short: "Amalfi-Küste, buntes Outfit, mediterran, Zitronen",
   full: "Ich an der Amalfi-Küste spazierend, buntes mediterranes Outfit, farbenfrohe italienische Häuser, Zitronenbäume, authentische italienische Atmosphäre, realistische Sommerstimmung"
 },
 {
   category: "realistic_natural",
   short: "Bali Reisterrassen, Boho-Outfit, tropisches Grün",
   full: "Ich bei den Tegallalang Reisterrassen auf Bali stehend, Boho-Style Outfit, saftig grüne Terrassen, tropische Vegetation, authentische balinesische Atmosphäre, realistische Naturfotografie"
 },
 {
   category: "realistic_natural",
   short: "Provence Lavendelfeld, Sommerkleid, violette Felder",
   full: "Ich in einem Provence Lavendelfeld stehend, luftiges Sommerkleid, endlose violette Lavendelreihen, französische Landschaft, authentische Provence-Atmosphäre, realistische Naturfotografie"
 },
 {
   category: "realistic_natural",
   short: "Schweizer Bergsee, Strickpullover, Holzsteg, Spiegelung",
   full: "Ich an einem Schweizer Bergsee auf einem Holzsteg stehend, gemütlicher Strickpullover, kristallklares Wasser das die Berge spiegelt, Alpine Kulisse, authentische Bergstimmung, realistische Naturfotografie"
 },
 {
   category: "realistic_candid",
   short: "Asiatischer Streetfood-Markt, lässiges Outfit, Garküchen, Dampf",
   full: "Ich auf einem lebhaften asiatischen Streetfood-Markt stehend, lässiges Alltags-Outfit, Garküchen mit dampfenden Töpfen um mich, authentisches Straßenleben, spontaner Schnappschuss-Moment, ungekünstelte Atmosphäre"
 },
 {
   category: "realistic_candid",
   short: "Festivalwiese, Boho-Outfit, Lichterketten, Bühne",
   full: "Ich auf einer Festivalwiese lachend, Boho-inspiriertes Outfit, Lichterketten überall, Bühne im Hintergrund, spontane Freude, authentischer Festival-Moment, candid Schnappschuss"
 },
 {
   category: "realistic_candid",
   short: "Berlin Street, Streetwear, Späti, urbanes Leben",
   full: "Ich vor einem Berliner Späti stehend, authentische Streetwear, urbanes Stadtleben um mich, spontaner Straßen-Moment, ungekünstelte Berliner Atmosphäre, candid Stadtfotografie"
 },
 {
   category: "realistic",
   short: "Minimalistisches Homeoffice, Loungewear, Laptop, große Fenster",
   full: "Ich in meinem minimalistischen Homeoffice arbeitend, gemütliche Loungewear, Laptop vor mir, große Fenster, authentische Arbeitsatmosphäre, realistischer Alltags-Moment, ungestellte Szene"
 },
 {
   category: "realistic",
   short: "Café-Arbeit, Casual, Laptop, Kaffee",
   full: "Ich in einem gemütlichen Café arbeitend, casual Alltags-Outfit, Laptop und Kaffeetasse vor mir, authentische Arbeitsatmosphäre, realistischer Alltags-Moment, ungekünstelte Szene"
 },
 {
   category: "realistic",
   short: "Bibliothek, smartes Outfit, Bücher, Lernszene",
   full: "Ich in einer historischen Bibliothek lernend, smartes Alltags-Outfit, Bücher vor mir, authentische Lern-Atmosphäre, natürliche Konzentration, realistischer Alltags-Moment"
 },
 {
   category: "street",
   short: "Tokyo Shibuya, Streetwear, Neonlichter, Zebrastreifen",
   full: "Ich in Tokyo Shibuya Kreuzung stehend, moderne Streetwear, Neonlichter überall, ikonischer Zebrastreifen, urbane japanische Atmosphäre, street photography style"
 },
 {
   category: "street",
   short: "LA Venice Beach, Skateboard-Outfit, Sonnenbrille, Graffiti",
   full: "Ich am Venice Beach Los Angeles laufend, lässiges Skateboard-Outfit, Sonnenbrille, bunte Graffiti-Wände, kalifornische Beach-Vibe, urbane Street-Atmosphäre, rohes Stadtleben"
 },
 {
   category: "street",
   short: "Berlin Rooftop, Streetstyle, Citylights, Fernsehturm",
   full: "Ich auf einem Berliner Rooftop stehend, authentischer Streetstyle, Citylights der Stadt, Fernsehturm in der Ferne, urbane Atmosphäre, rohe Street-Photography, Großstadt-Energie"
 },
 {
   category: "street",
   short: "Streetart-Galerie, urbanes Outfit, Graffitiwände, Spraydosen",
   full: "Ich in einer Streetart-Galerie stehend, urbanes Street-Outfit, massive Graffitiwände um mich, Spraydosen auf dem Boden, rohe urbane Atmosphäre, street photography style, Großstadt-Kultur"
 },
 {
   category: "street",
   short: "Cyberpunk Tokio, Techwear, Neonreklamen",
   full: "Ich in einem Cyberpunk Tokio stehend, futuristische Techwear, Neonreklamen, urbane Sci-Fi-Atmosphäre, street photography"
 },
 {
   category: "street",
   short: "Hong Kong Neonstraße, urbanes Outfit, Hochhäuser",
   full: "Ich in einer Hong Kong Neonstraße gehend, urbanes Street-Outfit, massive Hochhäuser mit Neonreklamen, dichtes Stadtleben, asiatische urbane Atmosphäre, street photography style"
 },
 {
   category: "street",
   short: "Amsterdamer Grachten, Fahrrad, Streetwear, Brückenlichter",
   full: "Ich an Amsterdamer Grachten mit Fahrrad stehend, lässige Streetwear, beleuchtete Brücken und Häuser, Kanal-Atmosphäre, urbanes Leben, street photography style"
 },
 {
   category: "nature",
   short: "Island Wasserfall, Outdoor-Jacke, Gischt, Felsen",
   full: "Ich an einem mächtigen isländischen Wasserfall stehend, wetterfeste Outdoor-Jacke, Wasser-Gischt um mich, schwarze Felsformationen, dramatische isländische Natur, Outdoor-Abenteuer-Fotografie"
 },
 {
   category: "nature",
   short: "Schweizer Alpen, Winterjacke, Schneelandschaft, Berghütte",
   full: "Ich in den Schweizer Alpen stehend, warme Winterjacke, endlose Schneelandschaft, traditionelle Berghütte im Hintergrund, majestätische Berggipfel, klare Bergluft, Alpine Outdoor-Fotografie"
 },
 {
   category: "nature",
   short: "Norwegen Fjord, Regenjacke, Bootssteg",
   full: "Ich an einem norwegischen Fjord auf einem Holzsteg stehend, robuste Regenjacke, Fjord-Berge, skandinavische Wildnis, Outdoor-Naturfotografie"
 },
 {
   category: "nature",
   short: "Safari Steppe, Khaki-Outfit, Geländewagen, Savanne",
   full: "Ich in der afrikanischen Safari-Steppe stehend, klassisches Khaki Safari-Outfit, Geländewagen im Hintergrund, endlose Savanne, wilde Natur, Outdoor-Abenteuer-Fotografie"
 },
 {
   category: "nature",
   short: "Patagonien Gletscher, Trekking-Outfit, Eisformationen, Berge",
   full: "Ich vor einem Patagonien Gletscher stehend, robustes Trekking-Outfit, massive Eisformationen, dramatische Bergkulisse, patagonische Wildnis, Outdoor-Expeditions-Fotografie"
 },
 {
   category: "nature",
   short: "Regenwald, Outdoor-Kleidung, große Blätter",
   full: "Ich tief im tropischen Regenwald stehend, funktionale Outdoor-Kleidung, riesige Dschungelblätter um mich, üppiges Grün, natürliche Wildnis-Atmosphäre, Outdoor-Naturfotografie"
 },
 {
   category: "nature",
   short: "Neuseeland Fjordland, Wanderoutfit, Bergsee, Spiegelung",
   full: "Ich in Neuseelands Fjordland an einem Bergsee stehend, praktisches Wanderoutfit, kristallklarer See das die Berge spiegelt, dramatische neuseeländische Alpen, unberührte Natur"
 },
 {
   category: "nature",
   short: "Yellowstone Geysir, Outdoor-Jacke, Dampf, Naturwunder",
   full: "Ich im Yellowstone Nationalpark vor einem Geysir stehend, wetterfeste Outdoor-Jacke, aufsteigender Dampf, farbige Thermalquellen, amerikanische Wildnis, Natur-Wunder-Fotografie"
 },
 {
   category: "action_standard",
   short: "Streetbasketball-Platz, Sportoutfit, Basketball",
   full: "Ich auf einem urbanen Streetbasketball-Platz in Aktion, dynamisches Sportoutfit, Basketball in der Hand, explosive Bewegung, gefrorener Action-Moment, sportliche Energie, high-speed Fotografie"
 },
 {
   category: "action_standard",
   short: "Urbanes Fitnessstudio, Trainingsoutfit, Hanteln, Spiegelwand",
   full: "Ich in einem modernen urbanen Fitnessstudio trainierend, funktionales Trainingsoutfit, Hanteln in Bewegung, Spiegelwand, intensive Action, gefrorene Bewegung, sportliche Energie, dynamische Fitness-Fotografie"
 },
 {
   category: "action_standard",
   short: "Surfer-Strand, Neoprenanzug, Wellen, Surfbrett",
   full: "Ich an einem Surfer-Strand stehend, Neoprenanzug, Surfbrett unter dem Arm, dramatische Wellen im Hintergrund, explosive Meer-Action, gefrorener Bewegungsmoment, sportliche Energie, action sports Fotografie"
 },
 {
   category: "action_standard",
   short: "Bergbiken Alpen, Bike-Outfit, MTB, steiler Trail",
   full: "Ich auf einem alpinen MTB-Trail fahrend, professionelles Bike-Outfit, Mountainbike in Action, steiler Trail, explosive Bewegung bergab, gefrorener Action-Moment, sportliche Bergkulisse, dynamische Outdoor-Action"
 },
 {
   category: "action_standard",
   short: "Skateparktrick, Skate-Outfit, Halfpipe, Jump",
   full: "Ich in einem Skatepark in der Luft, Skate-Outfit, Halfpipe, dramatischer Jump gefrorene Bewegung, explosive Action, urbane Skate-Atmosphäre, high-speed sports Fotografie"
 },
 {
   category: "action_standard",
   short: "Klettern Felswand, Kletter-Outfit, Seil, dramatische Höhe",
   full: "Ich an einer Felswand kletternd, funktionales Kletter-Outfit, Seil, dramatische Höhe, explosive Bewegung, gefrorener Action-Moment, sportliche Kletter-Energie, Outdoor-Action-Fotografie"
 },
 {
   category: "documentary_standard",
   short: "Marrakesch Basar, lockeres Outfit, Laternen, Gewürzstände",
   full: "Ich auf einem authentischen Marrakesch Basar gehend, lockeres Reise-Outfit, bunte Laternen über mir, Gewürzstände überall, lebendiges Marktleben, dokumentarischer Reportage-Stil, National Geographic Qualität"
 },
 {
   category: "documentary_standard",
   short: "Bangkok Tempel, luftiges Outfit, goldene Pagode, exotisch",
   full: "Ich vor einem Bangkok Tempel stehend, respektvolles luftiges Outfit, goldene Pagode, Räucherstäbchen-Rauch, authentisches thailändisches Leben, dokumentarischer Stil, kulturelle Reportage"
 },
 {
   category: "documentary_standard",
   short: "Mumbai Markt, traditionelles Outfit, Stände, Menschenmenge",
   full: "Ich auf einem lebhaften Mumbai Straßenmarkt stehend, traditionell inspiriertes Outfit, bunte Marktstände, Menschenmenge, authentisches indisches Straßenleben, dokumentarische Reportage-Fotografie"
 },
 {
   category: "documentary_standard",
   short: "Cusco Altstadt, Poncho, Kopfsteinpflaster, Peru",
   full: "Ich in der Cusco Altstadt in Peru gehend, traditionelle Poncho, Kopfsteinpflaster, historische Inka-Architektur, Anden-Atmosphäre, dokumentarischer Kultur-Reportage-Stil"
 },
 {
   category: "documentary_standard",
   short: "Petra Felsenstadt, Abenteuer-Outfit, rosarote Fassaden, Jordanien",
   full: "Ich vor der Petra Felsenstadt in Jordanien stehend, praktisches Abenteuer-Outfit, rosarote antike Fassaden, Wüstensand, historische Kulisse, dokumentarische Reportage-Fotografie"
 },
 {
   category: "realistic_natural",
   short: "Tauchbasis, Neoprenanzug, Surfbrett, türkisfarbenes Wasser",
   full: "Ich an einer Tauchbasis am Strand stehend, Neoprenanzug, Surfbrett neben mir, türkisfarbenes kristallklares Wasser, tropische Küste, authentische Surfer-Atmosphäre"
 },
 {
   category: "realistic_candid",
   short: "Strandspaziergang, Sommerkleid, barfuß",
   full: "Ich barfuß am Strand spazierend, luftiges Sommerkleid, Wellen die ans Ufer rollen, spontaner Strand-Moment, candid Urlaubs-Fotografie"
 },
 {
   category: "realistic_natural",
   short: "Rom Kolosseum, casual elegant, antike Arena, italienisch",
   full: "Ich am Kolosseum in Rom stehend, casual elegantes Outfit, die massive antike Arena hinter mir, italienischer Charme, historische Atmosphäre, authentische Rom-Stimmung"
 },
 {
   category: "realistic_natural",
   short: "Athen Akropolis, weißes Outfit, Säulen",
   full: "Ich auf der Athener Akropolis stehend, weißes luftiges Outfit, antike Säulen, historische Kulisse, authentische griechische Atmosphäre"
 },
 {
   category: "realistic_natural",
   short: "Prag Karlsbrücke, romantisches Outfit, gotisch",
   full: "Ich auf der Prager Karlsbrücke stehend, romantisches Outfit, gotische Türme, historische Brücke, tschechischer Charme, authentische Prag-Atmosphäre"
 },
 {
   category: "realistic_natural",
   short: "Stockholm Altstadt, Scandi-Style, Kopfsteinpflaster, nordisch",
   full: "Ich in Stockholms historischer Altstadt Gamla Stan gehend, skandinavischer minimalistischer Style, Kopfsteinpflaster, bunte nordische Häuser, schwedischer Charme"
 },
 {
   category: "street",
   short: "Istanbul Hagia Sophia, orientalisches Outfit, byzantinisch",
   full: "Ich vor der Hagia Sophia in Istanbul stehend, orientalisch inspiriertes Outfit, byzantinische Kuppel-Architektur, türkische Atmosphäre, historische Kulisse, kulturelle street photography"
 },
 {
   category: "realistic_natural",
   short: "Florenz Ponte Vecchio, elegantes Outfit, Arno, Renaissance",
   full: "Ich an der Ponte Vecchio in Florenz stehend, elegantes italienisches Outfit, der Arno Fluss, Renaissance-Architektur, florentinischer Charme, authentische Italien-Atmosphäre"
 },
 {
   category: "realistic_natural",
   short: "Edinburgh Castle, schottisches Outfit, Highlands, historisch",
   full: "Ich vor Edinburgh Castle stehend, schottisch inspiriertes Outfit, historische Festung, Highlands im Hintergrund, schottische Atmosphäre, authentische Schottland-Stimmung"
 },
 {
   category: "street",
   short: "San Francisco Golden Gate, casual chic, Brücke",
   full: "Ich an der Golden Gate Bridge stehend, casual chic Outfit, die ikonische rote Brücke, kalifornische Atmosphäre, urbane Street-Fotografie"
 },
 {
   category: "street",
   short: "Los Angeles Hollywood, glamourös, Walk of Fame, Sterne",
   full: "Ich am Hollywood Walk of Fame laufend, glamouröses LA-Outfit, Sterne auf dem Gehweg, Palmen, kalifornischer Vibe, street photography style"
 },
 {
   category: "street",
   short: "Miami South Beach, Beach-Outfit, Art Deco, Palmen",
   full: "Ich an der Miami South Beach flanierend, stylisches Beach-Outfit, Art Deco Gebäude in Pastellfarben, Palmen, tropischer Florida-Vibe, urbane Strand-Atmosphäre, street photography"
 },
 {
   category: "street",
   short: "New Orleans French Quarter, Jazz-inspiriert, Balkon, lebendig",
   full: "Ich im French Quarter von New Orleans gehend, Jazz-inspiriertes Outfit, schmiedeeiserne Balkone, lebendige Bourbon Street, New Orleans Atmosphäre, kulturelle street photography"
 },
 {
   category: "street",
   short: "Chicago Cloud Gate, modernes Outfit, Spiegelung, urban",
   full: "Ich vor dem Cloud Gate (The Bean) in Chicago stehend, modernes urbanes Outfit, Spiegelung in der Skulptur, Wolkenkratzer, Chi-Town Atmosphäre, urbane Street-Fotografie"
 },
 {
   category: "realistic_natural",
   short: "Boston Harvard, akademisches Outfit, Campus, intellektuell",
   full: "Ich auf dem Harvard Campus in Boston gehend, akademisches smart Outfit, historische Backsteingebäude, intellektuelle Atmosphäre, authentische Uni-Stimmung"
 },
 {
   category: "street",
   short: "Seattle Space Needle, Tech-casual, Coffee",
   full: "Ich vor der Space Needle in Seattle stehend, Tech-casual Pacific Northwest Outfit, Coffee-To-Go Cup, Seattle Atmosphäre, urbane Kaffeehauskultur, street photography"
 },
 {
   category: "street",
   short: "Toronto CN Tower, urbanes Outfit, Skyline, kanadisch",
   full: "Ich vor dem CN Tower in Toronto stehend, modernes urbanes Outfit, kanadische Skyline, multikulturelle Stadt-Atmosphäre, urbane street photography"
 },
 {
   category: "nature",
   short: "Vancouver Stanley Park, Outdoor-Outfit, Pazifik, Natur",
   full: "Ich im Stanley Park Vancouver gehend, sportliches Outdoor-Outfit, Pazifik-Blick durch die Bäume, kanadische Westküsten-Natur, Outdoor-Stadt-Natur-Fotografie"
 },
 {
   category: "realistic_candid",
   short: "Buenos Aires Tango, elegantes Kleid, La Boca, farbenfroh",
   full: "Ich in Buenos Aires La Boca tanzend, elegantes Tango-Kleid, farbenfrohe Häuser, argentinischer Straßentanz, spontaner Tango-Moment, candid kulturelle Fotografie"
 },
 {
   category: "documentary_standard",
   short: "Cartagena Kolumbien, tropisches Outfit, Kolonialstadt, karibisch",
   full: "Ich in Cartagenas bunter Kolonialstadt gehend, tropisches leichtes Outfit, farbenfrohe koloniale Architektur, karibisches Flair, kolumbianische Kultur, dokumentarische Reportage"
 },
 {
   category: "documentary_standard",
   short: "Mexiko City Frida Kahlo, künstlerisches Outfit, Casa Azul, bunt",
   full: "Ich vor der Casa Azul in Mexiko City stehend, künstlerisches Frida-inspiriertes Outfit, das blaue Haus, mexikanische Kunst-Atmosphäre, buntes kulturelles Ambiente, dokumentarische Kultur-Fotografie"
 },
 {
   category: "documentary_standard",
   short: "Machu Picchu, Trekking-Outfit, Inka-Ruinen, Peru",
   full: "Ich in Machu Picchu stehend, robustes Trekking-Outfit, mystische Inka-Ruinen, peruanische Anden-Berge, historische Kulisse, dokumentarische Expeditions-Fotografie"
 },
 {
   category: "realistic_natural",
   short: "Kyoto Tempelgarten, modernes Japan-Outfit, Ahornblätter, Steinpfad",
   full: "Ich in einem Kyoto Tempelgarten gehend, modernes Japan-inspiriertes Outfit, rote Ahornblätter, traditioneller Steinpfad, zen-buddhistische Atmosphäre, authentische japanische Garten-Stimmung"
 },
 {
   category: "realistic_natural",
   short: "Singapur Gardens, futuristisches Outfit, Supertrees, grün",
   full: "Ich in Singapurs Gardens by the Bay stehend, modernes futuristisches Outfit, massive Supertrees, grüne urbane Oase, futuristische Natur-Architektur"
 },
 {
   category: "documentary_standard",
   short: "Peking Verbotene Stadt, traditionelles Outfit, kaiserlich, rot",
   full: "Ich vor der Verbotenen Stadt in Peking stehend, traditionell inspiriertes Outfit, massive rote kaiserliche Mauern, chinesische Palast-Architektur, historische Atmosphäre, dokumentarische Kultur-Fotografie"
 },
 {
   category: "documentary_standard",
   short: "Delhi Taj Mahal, elegantes Outfit, weißer Marmor, romantisch",
   full: "Ich vor dem Taj Mahal in Delhi stehend, elegantes Outfit, der massive weiße Marmor-Palast, romantische Stimmung, indische Architektur-Pracht, dokumentarische Landmark-Fotografie"
 },
 {
   category: "documentary_standard",
   short: "Kairo Pyramiden, Safari-Outfit, Wüste, antik",
   full: "Ich vor den Pyramiden von Gizeh stehend, Safari-inspiriertes Outfit, die massiven antiken Pyramiden, Wüstensand, ägyptische Monumentalität, dokumentarische Expeditions-Fotografie"
 },
 {
   category: "street",
   short: "Kapstadt Tafelberg, Outdoor-Outfit, Bergblick, Südafrika",
   full: "Ich am Fuß des Kapstadt Tafelbergs stehend, sportliches Outdoor-Outfit, der massive Tafelberg über mir, südafrikanische Stadt-Natur-Kulisse, urbane Outdoor street photography"
 },
 {
   category: "realistic_natural",
   short: "Queenstown Neuseeland, Outdoor-Chic, Bergsee, Abenteuer",
   full: "Ich in Queenstown Neuseeland am Bergsee stehend, Outdoor-Chic Outfit, dramatische neuseeländische Alpen, kristallklarer See, Abenteuer-Atmosphäre, Outdoor-Reise-Fotografie"
 },
 {
   category: "street",
   short: "Kopenhagener Radweg, Fahrrad, Scandi-Mode, Design",
   full: "Ich auf einem Kopenhagener Radweg fahrend, minimalistischer Scandi-Mode Style, dänisches Stadtdesign, nordische Architektur, skandinavische Lebensqualität, urbane Lifestyle-Fotografie"
 },
 {
   category: "cinematic_epic",
   short: "Sci-Fi Raumschiff, futuristischer Anzug, Fensterfront, Sterne",
   full: "Ich im Kommandodeck eines Sci-Fi Raumschiffs stehend, futuristischer silberner Anzug, massive Fensterfront mit Sternenblick, Weltraum-Kulisse, epische Science-Fiction-Komposition, Blockbuster-Szenerie"
 },
 {
   category: "cinematic_vintage",
   short: "Mittelalterliche Altstadt, Umhang, Kopfsteinpflaster, Laternen",
   full: "Ich in einer mittelalterlichen Altstadt gehend, langer Umhang, Kopfsteinpflaster, flackernde Laternen, historische Fachwerkhäuser, mystische Mittelalter-Atmosphäre, Retro-Fantasy-Film-Look"
 },
 {
   category: "cinematic_epic",
   short: "Metropolis Zukunft, silberner Anzug, fliegende Autos, Wolkenkratzer",
   full: "Ich in einer futuristischen Metropolis stehend, glänzender silberner Anzug, fliegende Autos um mich, massive Wolkenkratzer, Sci-Fi Stadtkulisse, epische Zukunfts-Komposition"
 },
 {
   category: "realistic_natural",
   short: "Kyoto Bambuswald, Kimono, grüne Halme, Zen",
   full: "Ich im Kyoto Bambuswald Arashiyama gehend, traditioneller Kimono, endlose grüne Bambushalme, Zen-Atmosphäre, authentische japanische Kultur-Stimmung"
 },
 {
   category: "realistic_natural",
   short: "Bali Tempel, weißes Outfit, Tempelanlage, tropisch",
   full: "Ich vor einem Bali Wassertempel stehend, respektvolles weißes Outfit, balinesische Tempelarchitektur, tropische Vegetation, spirituelle Atmosphäre, authentische Insel-Kultur"
 },
 {
   category: "realistic_natural",
   short: "Angkor Wat, Outdoor-Chic, Tempelruinen, Dschungel",
   full: "Ich vor Angkor Wat in Kambodscha stehend, Outdoor-Chic Reise-Outfit, massive Khmer-Tempelruinen, Dschungel-Vegetation, historische Kulisse, authentische Tempel-Atmosphäre"
 },
 {
   category: "realistic",
   short: "Design-Café, Casual Smart, Latte Art, Minimalismus",
   full: "Ich in einem minimalistischen Design-Café sitzend, Casual Smart Outfit, Latte Art Kaffee vor mir, cleane Ästhetik, moderne Café-Atmosphäre, authentischer Alltags-Moment"
 },
 {
   category: "realistic",
   short: "Coworking Space, Business Casual, MacBook, moderne Einrichtung",
   full: "Ich in einem modernen Coworking Space arbeitend, Business Casual Outfit, MacBook vor mir, cleanes modernes Design, fokussierte Arbeitsatmosphäre, authentischer Arbeitsalltag"
 },
 {
   category: "realistic",
   short: "Rooftop-Brunch, sommerliches Outfit, Skyline",
   full: "Ich auf einer Rooftop-Terrasse beim Brunch sitzend, entspanntes sommerliches Outfit, Stadt-Skyline im Hintergrund, authentischer Lifestyle-Moment"
 },
 {
   category: "realistic_natural",
   short: "Botanischer Garten, Frühlingsoutfit, Glasgewächshaus, Blumen",
   full: "Ich in einem Botanischen Garten unter einem Glasgewächshaus stehend, frisches Frühlingsoutfit, exotische Blumen und Pflanzen, grüne Oase, authentische Garten-Atmosphäre"
 },
 {
   category: "realistic",
   short: "Buchladen, gemütliches Outfit, Bücherregale, Leseecke",
   full: "Ich in einer gemütlichen unabhängigen Buchhandlung stehend, entspanntes Outfit, Bücherregale bis zur Decke, Leseecke, intellektuelle Atmosphäre, authentischer Alltags-Moment"
 },
 {
   category: "street",
   short: "Gaming-Setup, Hoodie, RGB-Lichter, Monitorwand",
   full: "Ich an meinem Gaming-Setup sitzend, gemütlicher Hoodie, RGB-Lichter überall, Monitorwand mit Games, Tech-Höhle-Atmosphäre, urbane Gamer-Kultur, lifestyle photography"
 },
 {
   category: "realistic",
   short: "Tech-Konferenz, Business-Casual, Laptop, LED-Bühne",
   full: "Ich auf einer Tech-Konferenz stehend, Business-Casual Outfit, Laptop dabei, LED-Bühne im Hintergrund, moderne Tech-Atmosphäre, authentischer Konferenz-Moment"
 },
 {
   category: "street",
   short: "Startup-Office, Casual, Whiteboard, Team-Meeting",
   full: "Ich in einem modernen Startup-Office bei einem Meeting stehend, casual Workwear, Whiteboard mit Ideen, offenes Büro-Design, kreative Team-Atmosphäre, authentische Startup-Kultur"
 },
 {
   category: "realistic_natural",
   short: "Seychellen Traumstrand, Strandkleid, Granitfelsen, türkis",
   full: "Ich an einem Seychellen Traumstrand stehend, luftiges Strandkleid, massive Granitfelsen, türkisfarbenes Wasser, tropisches Paradies, authentische Insel-Atmosphäre"
 },
 {
   category: "realistic_natural",
   short: "Mauritius Strand, Beach-Outfit, Palmen, Korallenriff",
   full: "Ich an einem Mauritius Strand stehend, stilvolles Beach-Outfit, Palmen, türkisfarbene Lagune, Korallenriff-Wasser, tropische Insel-Atmosphäre, authentisches Paradies"
 },
 {
   category: "realistic_candid",
   short: "Thailand Longtailboot, Sommeroutfit, Kalksteinfelsen, Strand",
   full: "Ich in einem thailändischen Longtailboot sitzend, entspanntes Sommeroutfit, dramatische Kalksteinfelsen, kristallklares Wasser, tropischer Strand, spontaner Reise-Moment, candid Urlaubs-Fotografie"
 },
 {
   category: "street",
   short: "Taipei Nachtmarkt, casual Outfit, Streetfood, Neonzeichen",
   full: "Ich auf einem Taipei Nachtmarkt gehend, lässiges casual Outfit, Streetfood-Stände, bunte Neonzeichen, taiwanesisches Leben, urbane Markt-Atmosphäre, street food photography"
 },
 {
   category: "street",
   short: "Seoul Myeongdong, K-Fashion, Shopping, Neonreklamen",
   full: "Ich in Seouls Myeongdong Shopping-District gehend, trendige K-Fashion, bunte koreanische Neonreklamen, Shopping-Bags, urbanes koreanisches Leben, street photography style"
 },
 {
   category: "street",
   short: "Manhattan SoHo, modernes Outfit, Gusseisen-Architektur, Boutiquen",
   full: "Ich in Manhattan SoHo gehend, modernes Outfit, historische Gusseisen-Architektur, Boutiquen, modernes New Yorker Leben, street photography"
 },
 {
   category: "street",
   short: "Brooklyn Williamsburg, Hipster-Look, Street Art, Cafés",
   full: "Ich in Brooklyn Williamsburg gehend, authentischer Hipster-Look, massive Street Art Murals, Indie-Cafés, New Yorker Stadtteil-Vibe, urbane Subkultur, street photography style"
 },
 {
   category: "realistic_candid",
   short: "Oktoberfest München, Dirndl/Lederhose, Bierzelt, Festzelt",
   full: "Ich auf dem Oktoberfest München stehend, traditionelles Dirndl oder Lederhose, buntes Bierzelt, bayerische Festzelt-Atmosphäre, Maßkrug, spontaner Fest-Moment, candid Oktoberfest-Fotografie"
 },
 {
   category: "realistic_candid",
   short: "Karneval Rio, buntes Kostüm, Samba, Straßen-Party",
   full: "Ich beim Karneval in Rio tanzend, farbenfrohes Samba-Kostüm, Straßen voller Tänzer, brasilianische Party-Energie, spontaner Tanz-Moment, candid Karneval-Fotografie"
 },
 {
   category: "realistic_candid",
   short: "Venedig Karneval, venezianische Maske, historisches Kostüm, Markusplatz",
   full: "Ich am Markusplatz während des Venezianischen Karnevals stehend, prachtvolle venezianische Maske, historisches Kostüm, elegante Karnevals-Atmosphäre, italienischer Prunk, spontaner Karneval-Moment"
 },
 {
   category: "nature",
   short: "Kanada Rockies, Trekking-Outfit, Bergsee",
   full: "Ich in den kanadischen Rocky Mountains an einem türkisfarbenen Bergsee stehend, robustes Trekking-Outfit, dramatische Berggipfel, kanadische Wildnis"
 },
 {
   category: "nature",
   short: "Schottische Highlands, Wander-Outfit, Moor",
   full: "Ich in den schottischen Highlands über Moorland gehend, wetterfestes Wander-Outfit, Hügel, dramatische schottische Landschaft, mystische Wildnis, Outdoor-Highland-Fotografie"
 },
 {
   category: "nature",
   short: "Wüste Sahara, Nomaden-Outfit, Sanddünen, Kamel",
   full: "Ich in der Sahara-Wüste vor Sanddünen stehend, traditionelles Nomaden-inspiriertes Outfit, Kamel neben mir, endlose Wüste, nordafrikanische Wildnis, Outdoor-Wüsten-Fotografie"
 },
 {
   category: "nature",
   short: "Patagonien Torres, Outdoor-Gear, Gletscher",
   full: "Ich in Patagonien vor den Torres del Paine stehend, robustes Outdoor-Gear, Gletscher und Granitspitzen, dramatische Bergkulisse, Expeditions-Fotografie"
 },
 {
   category: "nature",
   short: "Alaskan Wilderness, Outdoor-Jacke, Grizzly-Gebiet, Wald",
   full: "Ich in der alaskischen Wildnis auf einem Trail stehend, robuste Outdoor-Jacke, dichter Nadelwald, Grizzly-Territorium, unberührte Natur, Outdoor-Wildnis-Fotografie"
 },
 {
   category: "nature",
   short: "Amazonas Dschungel, Expeditionskleidung, Urwald, Papageien",
   full: "Ich im Amazonas-Dschungel stehend, funktionale Expeditionskleidung, dichter tropischer Urwald, bunte Papageien, üppiges Grün, Outdoor-Expedition"
 },
 {
   category: "nature",
   short: "Grönland Eisberg, Polar-Outfit, Gletscher, Arktis",
   full: "Ich in Grönland vor massiven Eisbergen stehend, warmes Polar-Outfit, schwimmende Gletscher, arktische Landschaft, Outdoor-Arktis-Fotografie"
 },
 {
   category: "nature",
   short: "Neuseeland Milford Sound, Regenmantel, Fjord, Wasserfälle",
   full: "Ich im Milford Sound Neuseeland stehend, Regenmantel, dramatischer Fjord, Wasserfälle die von Klippen stürzen, neuseeländische Wildnis, Outdoor-Fjord-Fotografie"
 },
 {
   category: "nature",
   short: "Schottland Isle of Skye, Outdoor-Jacke, Klippen, Atlantik",
   full: "Ich auf der Isle of Skye in Schottland an Klippen stehend, robuste Outdoor-Jacke, dramatische Küstenklippen, stürmischer Atlantik, raue schottische Natur, Outdoor-Küsten-Fotografie"
 },
 {
   category: "realistic_candid",
   short: "Foodmarket, lässig, Street Food, dampfende Töpfe",
   full: "Ich auf einem internationalen Food Market stehend, lässiges Sonntagoutfit, Street Food Stände mit dampfenden Töpfen, multikulturelle Atmosphäre, spontaner Markt-Moment, candid street food photography"
 },
 {
   category: "realistic",
   short: "Yoga-Retreat, Sportswear, Matte, Natur",
   full: "Ich bei einem Outdoor Yoga-Retreat auf einer Matte sitzend, funktionale Sportswear, Natur um mich, friedliche Retreat-Atmosphäre, authentischer Wellness-Moment"
 },
 {
   category: "realistic_candid",
   short: "Flohmarkt-Bummel, Vintage-Look, Antiquitäten",
   full: "Ich auf einem Flohmarkt bummelnd, vintage-inspirierter Look, Antiquitäten und Schätze, spontaner Markt-Moment, candid Lifestyle-Fotografie"
 },
 {
   category: "realistic",
   short: "Picknick Park, Sommeroutfit, Decke, Obstkorb",
   full: "Ich in einem Park beim Picknick auf einer Decke sitzend, entspanntes Sommeroutfit, Obstkorb, friedliche Park-Atmosphäre, authentischer Sommer-Moment"
 },
 {
   category: "realistic",
   short: "Buchhandlung, Lesesessel, Bücherstapel, Kaffeetasse",
   full: "Ich in einer unabhängigen Buchhandlung in einem Lesesessel sitzend, gemütliches Outfit, Bücherstapel neben mir, Kaffeetasse, intellektuelle Atmosphäre, authentischer Lese-Moment"
 },
 {
   category: "realistic",
   short: "Vintage Plattenladen, Retro-Look, Vinylregale, Musik-Nerd",
   full: "Ich in einem Vintage Plattenladen zwischen Vinylregalen stehend, Retro-inspirierter Look, alte Schallplatten, Musik-Nerd-Atmosphäre, authentischer Musik-Liebhaber-Moment"
 },
 {
   category: "realistic_candid",
   short: "Farmers Market, lässig, Bio-Stände, Einkaufstasche",
   full: "Ich auf einem Farmers Market bummelnd, lässiges Sonntagoutfit, Bio-Gemüse-Stände, Einkaufstasche, spontaner Markt-Moment, candid Markt-Fotografie"
 },
 {
   category: "realistic",
   short: "Home Gym, Sportswear, Gewichte, Motivationsposter, Workout",
   full: "Ich in meinem Home Gym trainierend, funktionale Sportswear, Gewichte, Motivationsposter an der Wand, fokussierte Trainings-Atmosphäre, authentischer Workout-Moment"
 },
 {
   category: "realistic_candid",
   short: "Sonntags-Brunch, casual chic, Avocado Toast, Freunde, lachen",
   full: "Ich beim Sonntags-Brunch mit Freunden sitzend, casual chic Outfit, Avocado Toast vor mir, lachend, entspannte Brunch-Atmosphäre, spontaner Freunde-Moment, candid Lifestyle-Fotografie"
 },
 {
   category: "street",
   short: "Metaverse City, futuristisches Outfit, Neonlinien, Hologramme",
   full: "Ich in einer futuristischen Metaverse City gehend, futuristisches Tech-Outfit, Neonlinien überall, schwebende Hologramme, Sci-Fi urbane Atmosphäre, futuristische street photography"
 },
 {
   category: "street",
   short: "Night City Blade Runner, Cyberpunk-Look, Neon-Chaos",
   full: "Ich in einer Blade Runner inspirierten Night City stehend, dunkler Cyberpunk-Look, Neon-Chaos überall, dystopische urbane Atmosphäre, futuristische street photography"
 }
];

// Kategorien-Mapping für UI (Überschriften)
export const TEMPLATE_CATEGORIES = {
  "cinematic": {
    title: "Kino-Look",
    subtitle: "Standard",
    icon: "🎬"
  },
  "cinematic_epic": {
    title: "Hollywood",
    subtitle: "Blockbuster",
    icon: "🌟"
  },
  "cinematic_noir": {
    title: "Thriller-Look",
    subtitle: "Drama, Schatten",
    icon: "🎭"
  },
  "cinematic_vintage": {
    title: "Retro-Kinofilm",
    subtitle: "Vintage",
    icon: "📼"
  },
  "cinematic_moody": {
    title: "Melancholisches Kino",
    subtitle: "Düster",
    icon: "🌑"
  },
  "fashion": {
    title: "Fashion",
    subtitle: "Mode",
    icon: "👗"
  },
  "fashion_glamour": {
    title: "Fashion - Glamour",
    subtitle: "Hochglanz",
    icon: "💎"
  },
  "fashion_editorial": {
    title: "Fashion - Editorial",
    subtitle: "Vogue-Style",
    icon: "📰"
  },
  "fashion_vintage": {
    title: "Fashion - Vintage",
    subtitle: "Retro-Mode",
    icon: "📼"
  },
  "realistic": {
    title: "Realistisch - Standard",
    subtitle: "Neutrale, natürliche Fotos",
    icon: "📷"
  },
  "realistic_natural": {
    title: "Realistisch - Standard",
    subtitle: "Neutrale, natürliche Fotos",
    icon: "🌿"
  },
  "realistic_candid": {
    title: "Realistisch - Spontan",
    subtitle: "Schnappschuss",
    icon: "📸"
  },
  "action_standard": {
    title: "Action-Bewegung",
    subtitle: "Mehr Bewegung im Motiv",
    icon: "⚡"
  },
  "street": {
    title: "Street",
    subtitle: "Urban",
    icon: "🌆"
  },
  "nature": {
    title: "Natur",
    subtitle: "Outdoor",
    icon: "🏞️"
  },
  "documentary_standard": {
    title: "Dokumentarisch",
    subtitle: "Reportage",
    icon: "🎞️"
  }
};
